import { Component, ElementRef, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EXTRAS_ANCILLARY_MUSICAL, TRANSLATION_ANCILLARIES_TYPE, TRANSLATION_ANCILLARY_DETAILED, TRANSLATION_ANCILLARY_TEXTS, TRANSLATION_ANCILLARY_TITLE, TRANSLATION_EXTRA_MUSICAL, TRANSLATION_ANCILLARY_LABEL, SSR_CODE_MUSIC_INSTRUMENT_LARGE, SSR_CODE_MUSIC_INSTRUMENT_MEDIUM, SSR_CODE_MUSIC_INSTRUMENT_SMALL, TRANSLATION_ANCILLARY_ARIA_LABEL, SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET, SPECIAL_CASE_MARKET_LANGUAGE_MAP, ANCILLARY_PRODUCT_PACKS, ANCILLARY_GROUP_MUSIC_INSTRUMENT_LIST } from '@ibe.config';
import { INDRAAddOnAncillary } from '@ibe.models/ancillary.indra.model.lib';
import { INDRAAncillariesSelectionService } from '@ibe.services/ancillaries-selection.indra.service';
import { INDRAAncillariesShoppingCartService } from '@ibe.services/ancillaries-shopping-cart.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAMybService } from '@ibe/services';
import { SidebarService } from '@ibe/services/ui';
import { Subscription } from 'rxjs';
import { INDRAExtraSidebar } from '../extra-sidebar.indra.abstract';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import { INDRAGoogleAnalyticsService } from '@ibe.services/google.analytics.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { PaymentService } from '@ibe.components/shared/payment/payment.service';
import { INDRACurrencyPipe } from '@ibe.services/currency.indra.pipe';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRABookedTripDetails } from '@ibe.models/booked-trip-details.indra.model.lib';

@Component({
	selector: 'app-music-instruments',
	templateUrl: './music-instruments.indra.component.html',
	styleUrls: ['./music-instruments.component.scss'],
	providers: [INDRACurrencyPipe],
})
export class INDRAMusicInstrumentsComponent extends INDRAExtraSidebar
	implements OnInit, OnDestroy {

	@ViewChild('sidebar__notification') $notification: ElementRef;
	notificationShowing: boolean;
	notificationMessage: string;
	notificationDuration = 2.5; // in seconds
	lastActiveElement;
	departureLocation: string;

	// Initialization values
	show_all_options: boolean;
	formsPerPassenger: FormGroup[];

	translationAncillaryDetailedKey = TRANSLATION_ANCILLARY_DETAILED;

	allSubscriptions: Subscription[] = [];
	paramSubscription: Subscription;
	loadedSubscription: Subscription;

	milesNeeded = 0;
	addedAncillary: any = [];
	removedAncillary: any;
	isModificationDisallowed: boolean = false;

	aggregateSale: string = null;

	booked_trip: INDRABookedTripDetails;
	notEnoughMilesFlag: boolean = false;
	hasAddedExtrasFlag: boolean;


	constructor(
		sidebarService: SidebarService,
		route: ActivatedRoute,
		router: Router,
		bookingService: INDRABookingService,
		mybService: INDRAMybService,
		ibeAdminService: INDRAIbeAdminService,
		ancillariesSelectionSrv: INDRAAncillariesSelectionService,
		ancillariesShoppingCartSrv: INDRAAncillariesShoppingCartService,
		private fb: FormBuilder,
		dateService: INDRADateService,
		googleAnalytics: INDRAGoogleAnalyticsService,
		storageService: INDRAStorageService,
		store: Store<fromStore.State>,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
		protected currencyPipe: INDRACurrencyPipe,
		protected paymentInfoService: PaymentService,
		protected bfmStorageService: INDRABFMDataStorageService,
	) {
		super(sidebarService, route, router, bookingService, mybService, ibeAdminService, ancillariesSelectionSrv, ancillariesShoppingCartSrv, EXTRAS_ANCILLARY_MUSICAL, dateService, googleAnalytics, storageService, store, currencyPipe, paymentInfoService);
		this.formsPerPassenger = [];

		this.loadedSubscription = this.isLoaded.subscribe(
			res => {
				if (res) {
					this.showNotification('addMoreSidebars.specialMeals.texts.appliedSuccessfullyToOtherFlights');
				}
			}
		);
		this.allSubscriptions.push(this.loadedSubscription);
		
		// get 'isBookingCreated' if existing in URL query params (if true, modification in the sidebar is not allowed)
		const isBookingCreatedParam = this.route.snapshot.paramMap.get('isBookingCreated');
		if (isBookingCreatedParam === 'true') {
			this.isModificationDisallowed = true;
		}
	}

	ngOnInit() {
		this.storageService.set('ancType', EXTRAS_ANCILLARY_MUSICAL);

		this.booked_trip = this.bfmStorageService.INDRA_getActiveBookedTrip();

		this.paramSubscription = this.route.params.subscribe(params => {
			this.flightCardId = this.route.snapshot.paramMap.get('flight');
			this.flight = this.bookingService.INDRA_getBookedFlight(this.flightCardId);
			if (params.aggregateSale && params.aggregateSale != null && params.aggregateSale != undefined && params.aggregateSale != 'undefined') {
				this.aggregateSale = params.aggregateSale;
			}
			this.flightRouteInput = (!this.aggregateSale) ? this.bookingService.INDRA_getFlightRoute(this.flight) : this.bookingService.INDRA_getFlightRouteAggregate(this.flight, this.aggregateSale);
			this.departureLocation = this.INDRA_fetchDepartureLocation();
			this.passengers = this.bookingService.INDRA_getPaxInfo(false);
			this.passengers.forEach(passenger =>
				this.formsPerPassenger.push(this.createFormGroup())
			);

			super.ngOnInit();
			
			for (const i in this.passengers) {
				const feature = this.INDRA_getAddedAncillariesForPassenger(this.passengers[i].idPax);
				if (feature.length != 0) {
					const shoppingCartItems = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
					for (const x in feature) {
						this.addedAncillary.push(feature[x]);
						this.milesNeeded = this.milesNeeded + feature[x].points;
						// this.payWithMiles = shoppingCartItems.itemsAdded.find(item => item.type == feature[x].type).payWithMiles;
					}
				}
			}
		});

		this.payWithMiles = this.INDRA_isPayWithMiles();

		this.allSubscriptions.push(this.paramSubscription);

		this.hasAddedExtrasFlag = this.INDRA_getInitialAddedExtras('MUSICAL');

		this.INDRA_checkAncillaryInPack()
	}

	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}


	private createFormGroup() {
		return this.fb.group({
			musicInstrumentsAdd: null,
			weightCheck: false,
			dimensionCheck: false
		});
	}


	INDRA_hasNextFlight() {
		return this.bookingService.INDRA_hasNextFlight(this.flightCardId);
	}

	INDRA_copyToOtherFlights() {
	}

	INDRA_flowActionsClasses() {
		return { 'flow_actions--wide': !this.INDRA_hasNextFlight() };
	}

	INDRA_handleNext() {
		const nextFlightIdentifier = this.bookingService.INDRA_getNextFlightCardId(this.flightCardId);
		if (nextFlightIdentifier > 0) {
			this.router.navigate([
				{ outlets: { sidebar: ['ancillaries--music-instruments', { flight: nextFlightIdentifier}] } }
			]);
		} else {
			super.INDRA_handleClose();
		}
	}

	INDRA_printAddButtonLabel(idPax: number) {
		const features = this.INDRA_getAddOnForPassenger(idPax);
		const feature = features[0];
		return 'Add '
			+ this.INDRA_getTranslation(`${this.translationAncillaryDetailedKey + feature.code}`)
			+ ' ('
			+ feature.price + ' '
			+ this.INDRA_getCurrencySymbol(feature.currency)
			+ ')';
	}

	INDRA_printAddedButtonLabel(idPax: number) {
		const features = this.INDRA_getAddOnForPassenger(idPax);
		const feature = features[0];
		return this.INDRA_getTranslation(`${this.translationAncillaryDetailedKey + feature.code}`)
			+ ' added';
	}

	INDRA_printRemoveButtonLabel(idPax: number) {
		const features = this.INDRA_getAddOnForPassenger(idPax);
		const feature = features[0];
		return feature.price + this.INDRA_getCurrencySymbol(feature.currency);
	}

	INDRA_getTitle() {
		return this.INDRA_getTranslation(`${TRANSLATION_ANCILLARIES_TYPE + EXTRAS_ANCILLARY_MUSICAL}`);
	}

	INDRA_printDepartureLocation() {
		return this.departureLocation;
	}

	INDRA_fetchDepartureLocation() {
		const departureLocationObj = this.bookingService.INDRA_DepartureLocationOfFlight(this.flightCardId.toString());
		if (departureLocationObj) {
			return departureLocationObj.name;
		}

		return '';
	}

	INDRA_getTextTranslation(lastKey: string) {
		const key = TRANSLATION_EXTRA_MUSICAL + TRANSLATION_ANCILLARY_TEXTS + lastKey;
		return key;
	}

	INDRA_getAriaLabelTranslation(lastKey: string) {
		const key = TRANSLATION_EXTRA_MUSICAL + TRANSLATION_ANCILLARY_ARIA_LABEL + lastKey;
		return key;
	}

	INDRA_getTitleTranslation(lastKey: string) {
		const key = TRANSLATION_EXTRA_MUSICAL + TRANSLATION_ANCILLARY_TITLE + lastKey;
		return key;
	}

	INDRA_getLabelTranslation(lastKey: string) {
		const key = TRANSLATION_EXTRA_MUSICAL + TRANSLATION_ANCILLARY_LABEL + lastKey;
		return key;
	}

	INDRA_chosenValue(targetPassengerIndex: number) {
		const form = this.formsPerPassenger[targetPassengerIndex];
		const formValue = form.get('musicInstrumentsAdd').value;
		if (formValue) {
			const value: INDRAAddOnAncillary = JSON.parse(formValue);
			return value;
		}
		return form.get('musicInstrumentsAdd').value;
	}

	INDRA_hasCheckedRequirements(targetPassengerIndex) {
		const form = this.formsPerPassenger[targetPassengerIndex];
		return form.get('weightCheck').value && form.get('dimensionCheck').value && this.INDRA_chosenValue(targetPassengerIndex);
	}

	INDRA_resetPassengerForm(targetPassengerIndex) {
		// this.formsPerPassenger[targetPassengerIndex] = this.createFormGroup();
		const form = this.formsPerPassenger[targetPassengerIndex];
		form.get('musicInstrumentsAdd').setValue('');
		form.get('dimensionCheck').setValue(false);
		form.get('weightCheck').setValue(false);
		form.updateValueAndValidity();
	}

	INDRA_chosenValueFromCollection(targetPassengerIndex: number): INDRAAddOnAncillary {
		const idPax = this.passengers[targetPassengerIndex].idPax;
		const chosenVal = this.INDRA_chosenValue(targetPassengerIndex);
		const ancillaries = this.INDRA_getAddOnForPassenger(idPax);

		const ancillaryDetails = ancillaries.find((val) => JSON.stringify(Object.entries(val).sort()) == JSON.stringify(Object.entries(chosenVal).sort()));
		this.addedAncillary.push(ancillaryDetails);
		this.milesNeeded = this.milesNeeded + ancillaryDetails.points;

		this.hasAddedExtrasFlag = this.addedAncillary.length > 0 ? true : false;

		return ancillaryDetails;
	}

	INDRA_getWeightLimit(formValue: any) {
		if (formValue && formValue.musicInstrumentsAdd) {
			const instrument = JSON.parse(formValue.musicInstrumentsAdd);
			switch (instrument.code) {
				case (SSR_CODE_MUSIC_INSTRUMENT_LARGE):
					return '45 Kg';
				case (SSR_CODE_MUSIC_INSTRUMENT_MEDIUM):
					return '32 Kg';
				case (SSR_CODE_MUSIC_INSTRUMENT_SMALL):
					return '23 Kg';
				default:
					return '45 Kg';
			}
		}

	}

	INDRA_getStopoverNotificationTitle() {
		return this.INDRA_getTranslation('addMoreSidebars.musicInstruments.titles.extraForWhole') + ' '
			+ this.INDRA_getBoundType() + ' ' +
			this.INDRA_getTranslation('addMoreSidebars.musicInstruments.titles.trip');
	}

	ngOnDestroy() {
		for (const sub of this.allSubscriptions) {
			if (sub) {
				sub.unsubscribe();
			}
		}
	}

	private showNotification(message: string) {
		this.notificationMessage = this.INDRA_getTranslation(message);
		this.notificationShowing = true;
		window.setTimeout(this.dismissNotification.bind(this), this.notificationDuration * 1000);

		this.lastActiveElement = document.activeElement;
		// this.$notification.nativeElement.focus();
	}

	dismissNotification() {
		this.notificationShowing = false;
		this.lastActiveElement.focus();
	}

	INDRA_removeAncillary(ancillary: any) {
		this.addedAncillary = this.addedAncillary.filter(item => item.paxId != ancillary.paxId);
		this.hasAddedExtrasFlag = this.INDRA_handleRemoveAncillary(ancillary);
		this.milesNeeded = this.milesNeeded - ancillary.points;

		sessionStorage.removeItem("is"+EXTRAS_ANCILLARY_MUSICAL+"withMiles");
		this.INDRA_checkMiles();
	}

	INDRA_processAncillary() {
		this.notEnoughMilesFlag = this.INDRA_handleProcessAncillaries(EXTRAS_ANCILLARY_MUSICAL, this.addedAncillary, this.milesNeeded, this.booked_trip);
	}

	INDRA_getOptionList(index) {
		this.INDRA_getInputOptions();
		return this.optionList[index];
	}

	INDRA_checkMiles(){
		
		const shoppingCartItems = this.storageService.get('INDRAAncillariesShoppingCartService.shoppingCart');
		const musicalItems:any = [];
		if(shoppingCartItems.itemsAdded.length === 0 ){
				return false;
		} else if (shoppingCartItems.itemsAdded.length != 0){
				for (const i in shoppingCartItems.itemsAdded) {
					if(shoppingCartItems.itemsAdded[i].type === "MUSICAL"){

						musicalItems.push(shoppingCartItems.itemsAdded[i]);

						if(musicalItems.length < 1){
							return false;
						}

						const isPaidWithMiles = sessionStorage.getItem("is"+shoppingCartItems.itemsAdded[i].type+"withMiles");
						if(isPaidWithMiles === null){
							return false;
						}
						if(String(shoppingCartItems.itemsAdded[i].payWithMiles) === isPaidWithMiles){
							return false;
						} else {
							return true;
						}
					}
	
				}
		}

		return false;
		
	}


	INDRA_checkAncillaryInPack() {
			if (this.shoppingCartContent.itemsAdded.length) {
				this.shoppingCartContent.itemsAdded.forEach(item => {
					if (ANCILLARY_PRODUCT_PACKS.includes(item.code) && item.flightId == this.flight.idFlight) {
						// Item is pack
						for (let i = 0; i < this.booked_trip['ancillaries-data'].packList.length; i++) {
							let pack = this.booked_trip['ancillaries-data'].packList[i];
							if (pack.ancillaryList[0].type === item.code) {
								let ancillary = pack.ancillaryList[0].catalog[0].passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.find(anc => ANCILLARY_GROUP_MUSIC_INSTRUMENT_LIST.includes(anc.code))
								if (ancillary) {
									// If music instrument included in added pack, disable added music instrument
									this.passengers.forEach(passenger => {
										const index = this.paxAddOnFeatures[this.flightCardId].findIndex(
											item => Object.keys(item)[0] === passenger.idPax.toString()
										);
										this.paxAddOnFeatures[this.flightCardId][index][passenger.idPax].forEach(item => {
											if (item.code == ancillary.code) {
												item.enabled = false;
											}
										});
									});
								}
							}
						}
					}
				});
			}
		}
}
